module.exports = "img/social/linkedin.5764540.png";